const isSentimentAppVersion = () => {
  return window.location.href.includes("sentiment");
};

export { isSentimentAppVersion };
